import { useLocation } from '@reach/router'
import { useEffect, useState } from 'react'

export const BASE_PATHS = [
  '/',
  '/package/web/',
  '/package/message/',
  '/package/app/',
  '/package/signals/',
  '/feature/core-realtime/',
  '/feature/core-batch/',
] as const

const LOCALIZED_PATHS = [...BASE_PATHS, ...BASE_PATHS.map((path) => (path === '/' ? '/en/' : `/en${path}`))] as const

/**
 * A type-safe hook that checks if the current path follows the project's localization patterns.
 *
 * This hook is part of the project's internationalization strategy and follows the
 * established pattern for handling localized paths:
 * - Japanese paths: Standard paths without prefix ('/', '/package/web/')
 * - English paths: Paths with '/en' prefix ('/en/', '/en/package/web/')
 *
 * The hook uses LOCALIZED_PATHS constant to validate paths against predefined
 * localization patterns, ensuring type safety and consistent behavior.
 *
 * @see LOCALIZED_PATHS for the complete list of supported path patterns
 */
export const useLocalizedPath = (): boolean => {
  const location = useLocation()
  const [hasLocalizedPath, setHasLocalizedPath] = useState<boolean>(false)

  useEffect(() => {
    setHasLocalizedPath(LOCALIZED_PATHS.indexOf(location.pathname) !== -1)
  }, [location.pathname])

  return hasLocalizedPath
}
